<template>
  <section>

    <div class="carousel" data-flickity>
      <div class="carousel-cell container-fluid has-text-centered" :class="item.className" :style="item.style" v-for="item in data">
        <div class="text-box">
          <div class="text-center wow bounceInDown" > 
         
            <div v-html="item.html">
              
            </div>
            <p v-if="item.link">
                 <router-link :to="item.link.href">{{item.link.text}}</router-link>
            </p>
          </div>
          
        </div>
      </div>

    </div>

  </section>
</template>
<script>
import WOW from 'wowjs'
import 'wowjs/css/libs/animate.css'

export default {
  name: 'slide',
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    dynamicHeight: () => {
      return window.innerWidth < 769 ? '300px' : '550px'
    }
  },
  mounted() {
    const lib = WOW.WOW
    const Wow = new lib()
    Wow.init();
    
    let flag = false;

    if(this.data.length > 1){
      flag = true;
    }

    $('.carousel').flickity({
      cellAlign: 'left',
      contain: true,
      prevNextButtons:flag,
      pageDots:flag
    })
  }
}
</script>

<style lang="scss" >

$yellow: #F3AB3C;
$gray:#e6e6e6;


.carousel {
  background: #EEE;
}

.carousel-cell {
  width: 100%;
  height: 550px;
  margin-right: 10px;
  &.container-fluid {
    &.banner1{
      background: url('~@/assets/images/desktop/banner.jpg') no-repeat center center;
    }
    &.banner2{
      background: url('~@/assets/images/desktop/banner_principal_desktop3.jpg') no-repeat center center;
    }
    &.banner3{
      background: url('~@/assets/images/desktop/banner_principal_desktop2.jpg') no-repeat center center;
    }
      background-size: cover;
      height: 550px;

    .text-box {
      height: 100%;
      width: 50%;
      margin: auto;
      color: white;
      font-family: 'Montserrat';
      display: table;
      .text-center {
        display: table-cell;
        vertical-align: middle;
        h1 {
          line-height: 1;
          span {
            font-weight: 300;
          }
          font-size: 2.4rem;
        }
        p {
          margin: 1em 0 2em;
        }
        a {

          background: $yellow;
          color: black;
          padding: .8em;
        }
      }
    }


    @media only screen and (max-width:48.0625em) {
      &.banner1{

      background: url('~@/assets/images/mobile/banner_principal_mobile1.jpg') no-repeat center center;
      }
      &.banner2{

      background: url('~@/assets/images/mobile/banner_principal_mobile3.jpg') no-repeat center center;
      }
      &.banner3{

      background: url('~@/assets/images/mobile/banner_principal_mobile2.jpg') no-repeat center center;
      }
      background-size: cover;
      .text-box {
        width: 100%;
        padding: 5%;
        h1 {
          font-size: 1.8rem;
        }
      }
    }

    @media only screen and (max-width:29.25em) {
      .text-box {
        h1 {
          font-size: 1.8rem;
        }
      }
    }

    @media only screen and (max-width:22em) {


      .text-box {
        h1 {
          font-size: 1.3rem;
        }
        p {
          font-size: .8rem;
        }
        a {

          font-size: .8rem;
        }
      }
    }
  }

  &:before {
    display: block;
    text-align: center;
    line-height: 550px;
    font-size: 80px;
    color: white;
  }
}

.flickity-page-dots {
  bottom: 20px;
  &.dot {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: transparent;
    border: 2px solid white;
  }
  &.dot.is-selected {
    background: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/slide.vue